export enum UserStatus {
  ACTIVE = 1,
  INACTIVE = 2,
  BLOCKED = 3,
}

export enum RoleUser {
  UNDEFINED = 0,
  ADMIN = 1,
  CLIENT = 2,
  LOADER = 3,
  CONSULTANT = 4,
}

